import { Buffer } from 'buffer';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { initializeApp } from './libs/init/exec.init';
import { canonicalizeAuthTrailingSlash } from './shared/routerUtils/canonicalizeAuthTrailingSlash';
import { routes } from './routing/routes';
import { getAppBasename } from './hooks/useAppRouter/getAppBasename';

// Some dependencies (e.g. `isemail`) expect a global `Buffer`. The `buffer`
// alias in `vite.config.ts` provides the module; expose it globally before any
// app code that relies on it runs.
globalThis.Buffer ??= Buffer;

/**
 * Client entry for the Vite SPA: normalize auth URLs, run app init, then mount
 * React Router 7 synchronously (pure CSR).
 */
canonicalizeAuthTrailingSlash();

await initializeApp();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Missing #root element');
}

const router = createBrowserRouter(routes, { basename: getAppBasename() });

createRoot(rootElement).render(<RouterProvider router={router} />);
